import cadd from "../models/cadd";

export const types = {
  TOGGLE_TOAST: "TOGGLE_TOAST",
  ADDITIONAL_INFORMATION_REQUESTED: "ADDITIONAL_INFORMATION_REQUESTED",
  ADDITIONAL_INFORMATION_SUCCEDDED: "ADDITIONAL_INFORMATION_SUCCEDDED",
  ADDITIONAL_INFORMATION_FAILED: "ADDITIONAL_INFORMATION_FAILED",
  GET_PROJECTS_REQUESTED: "GET_PROJECTS_REQUESTED",
  GET_PROJECTS_SUCCEDDED: "GET_PROJECTS_SUCCEDDED",
  GET_PROJECTS_FAILED: "GET_PROJECTS_FAILED",
  GET_PROJECT_REQUESTED: "GET_PROJECT_REQUESTED",
  GET_PROJECT_SUCCEDDED: "GET_PROJECT_SUCCEDDED",
  GET_PROJECT_FAILED: "GET_PROJECT_FAILED",
  NEW_PROJECT: "NEW_PROJECT",
  NEW_PROJECT_SUCCEDDED: "NEW_PROJECT_SUCCEDDED",
  NEW_PROJECT_FAILED: "NEW_PROJECT_FAILED",
  UPDATE_PROJECT_STATUS_REQUESTED: "UPDATE_PROJECT_STATUS_REQUESTED",
  UPDATE_PROJECT_STATUS_SUCCEDDED: "UPDATE_PROJECT_STATUS_SUCCEDDED",
  UPDATE_PROJECT_STATUS_FAILED: "UPDATE_PROJECT_STATUS_FAILED",
};

export const actions = {
  submitAdditionalInformation: (payload) => {
    return { type: types.ADDITIONAL_INFORMATION_REQUESTED, value: payload };
  },
  setSubmitted: (payload) => {
    return { type: types.TOGGLE_TOAST, value: payload };
  },
  setErrors: (payload) => {
    return { type: types.ADDITIONAL_INFORMATION_FAILED, value: payload };
  },
  // getProjects: () => {
  //   return { type: types.GET_PROJECTS_REQUESTED };
  // },
  // getProject: id => {
  //   return { type: types.GET_PROJECT_REQUESTED, value: id };
  // },
  submitNewProject: payload => {
    return { type: types.NEW_PROJECT, value: payload };
  },
  updateProjectStatus: (id, status) => {
    return { type: types.UPDATE_PROJECT_STATUS_REQUESTED, value: { id, status } };
  },
};

const reducer = (state = cadd, action) => {
  switch (action.type) {
    case types.ADDITIONAL_INFORMATION_REQUESTED:
      return {
        ...state,
        submiting: true,
      };

    case types.ADDITIONAL_INFORMATION_SUCCEDDED:
      return {
        ...state,
        submiting: false,
        submitted: true,
      };
    case types.TOGGLE_TOAST:
      return {
        ...state,
        submitted: action.value || false,
      };
    case types.ADDITIONAL_INFORMATION_FAILED:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null,
      };

    case types.GET_PROJECTS_SUCCEDDED:
      return {
        ...state,
        projects: Array.isArray(action.value) ? action.value.map(project => Object.assign(project, { collapse: true })) : action.value
      }
    case types.GET_PROJECT_SUCCEDDED:
      return {
        ...state,
        project: action.value,
      }
    case types.NEW_PROJECT_SUCCEDDED:
      return {
        ...state,
        submitted: true,
        projects: action.value.map(project => Object.assign(project, { collapse: true }))
      }
    case types.NEW_PROJECT_FAILED:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null
      }

    case types.UPDATE_PROJECT_STATUS_FAILED:
      return {
        ...state,
        submiting: false,
        submitted: false,
        errors: action.value || null
      }

    case types.UPDATE_PROJECT_STATUS_SUCCEDDED:
      return {
        ...state,
        submitted: true,
      }

    default:
      return state;
  }
};

export default reducer;
